import { useState } from 'react'
import { IconButton, Menu, MenuItem, Typography } from '@mui/material'
import { IconDots, IconEdit, IconTrash } from '@tabler/icons-react'

interface ProductActionsMenuProps {
  onEdit: () => void
  onDeleteClick: () => void
}

const ProductActionsMenu = ({ onEdit, onDeleteClick }: ProductActionsMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleEdit = () => {
    handleClose()
    onEdit()
  }

  const handleDelete = () => {
    handleClose()
    onDeleteClick()
  }

  return (
    <>
      <IconButton
        onClick={handleOpen}
        size="small"
        sx={{ color: 'primary.main', '&:hover': { bgcolor: 'primary.light' } }}
      >
        <IconDots size={20} />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
            borderRadius: '8px',
            minWidth: '140px',
          },
        }}
      >
        <MenuItem onClick={handleEdit}>
          <IconEdit size={18} color="#220D77" />
          <Typography pl={0.5} pt={0.35} variant="body2" color="primary">
            Edit
          </Typography>
        </MenuItem>
        <MenuItem onClick={handleDelete}>
          <IconTrash size={18} color="#F64336" />
          <Typography pl={0.5} pt={0.35} variant="body2" color="error">
            Delete
          </Typography>
        </MenuItem>
      </Menu>
    </>
  )
}

export default ProductActionsMenu
